import { CSSProperties } from 'react'
import Caution from '../../../Assets/Images/svgs/caution-icon'
import { useActiveWindow } from '../../../Context/ActiveWindowProvider'

interface ActiveWindowBannerProps {
  style?: CSSProperties
}

const ActiveWindowBanner = ({ style }: ActiveWindowBannerProps) => {
  const { message, hasActiveWindow } = useActiveWindow()

  if (!hasActiveWindow) return null

  return (
    <div className='revoke-access-message' style={style} data-testid='active-window-banner'>
      <Caution />
      <span>{message}</span>
    </div>
  )
}

export default ActiveWindowBanner
